import { defineComponent as _defineComponent } from 'vue';
import { renderMarkdown } from '~/functions/markdown';
import { getClickableLink } from '~/functions/helpers';
export default /*#__PURE__*/_defineComponent({
  __name: 'ConceptContent',
  props: {
    label: String,
    description: String,
    additionalData: Object
  },
  setup: function setup(__props) {
    var props = __props;
    var howCanYou = computed(function () {
      var _props$additionalData, _props$additionalData2;
      return props === null || props === void 0 ? void 0 : (_props$additionalData = props.additionalData) === null || _props$additionalData === void 0 ? void 0 : (_props$additionalData2 = _props$additionalData.insights) === null || _props$additionalData2 === void 0 ? void 0 : _props$additionalData2.howCanYou;
    });
    var howDoOthers = computed(function () {
      var _props$additionalData3, _props$additionalData4;
      return props === null || props === void 0 ? void 0 : (_props$additionalData3 = props.additionalData) === null || _props$additionalData3 === void 0 ? void 0 : (_props$additionalData4 = _props$additionalData3.insights) === null || _props$additionalData4 === void 0 ? void 0 : _props$additionalData4.howDoOthers;
    });
    return {
      __sfc: true,
      props: props,
      howCanYou: howCanYou,
      howDoOthers: howDoOthers,
      renderMarkdown: renderMarkdown,
      getClickableLink: getClickableLink
    };
  }
});